import clsx from 'clsx';
import React from 'react';
import { Container } from 'react-bootstrap';

import Button from '@components/Button';
import {
  CORPORATE_SUBSCRIPTION_FORM_URL,
  MEDIA_KIT_URL,
  PARTNERSHIP_FORM_URL,
  PARTNERSHIP_IMAGE_URL,
} from '@utils/constants';

import styles from './styles.module.scss';

const PartnershipOpportunitiesSection = () => {
  return (
    <div id="partnerships" className={styles.partnershipBackground}>
      <Container>
        <div className="grid grid-cols-12">
          <div className="col-span-12 md:col-start-1 md:col-end-8">
            <h1 className={styles.partnershipSubTitle}>
              <span className={styles.partnershipTitle}>Partnership Opportunities</span> Why The
              Information
            </h1>
            <div className={styles.partnershipContent}>
              {/* Note: Any copy changes below will also need to be made in app/controllers/api/snippets_controller.rb */}
              The Information is one of the most trusted and heavily cited publications covering the
              technology industry. For nearly a decade we have broken many of the most important
              stories in the industry &mdash; often years before other publications catch on. We
              arguably have the largest engaged subscriber base of startup founders, venture
              capitalists, and technology decision makers in the world. There are several ways we
              work with corporate partners including:
              <p className={styles.bulletPoint}>
                <span className={styles.bulletTitle}>Corporate Subscriptions:</span> Empower your
                team with deep industry knowledge and the ability to engage on our platform with
                other subscribers.{' '}
                <Button
                  className={styles.bulletLink}
                  href={`${CORPORATE_SUBSCRIPTION_FORM_URL}?source=partner_tab`}
                  trackClick
                  trackingProps={{
                    name: 'corporate_subscription_form',
                    location: 'partnership_opportunities',
                  }}
                  variant="link"
                >
                  Learn more about corporate subscriptions.
                </Button>
              </p>
              <p className={styles.bulletPoint}>
                <span className={styles.bulletTitle}>Corporate Partnerships:</span> For select
                partners who want their brand and message in front of our community and associated
                with true quality, independent journalism.
              </p>
            </div>
            <div className="flex flex-col-reverse items-center sm:flex-row">
              <Button
                href={`${PARTNERSHIP_FORM_URL}?source=partner_tab`}
                className={clsx(styles.blackButton)}
                rounded="slight"
                trackClick
                trackingProps={{
                  name: 'partnership_form',
                  location: 'partnership_opportunities',
                }}
              >
                Get in contact
              </Button>
              <Button
                href={MEDIA_KIT_URL}
                className="mt-24 text-primary-red visited:text-primary-red sm:mt-0"
                trackClick
                trackingProps={{
                  name: 'media_kit',
                  location: 'partnership_opportunities',
                }}
                variant="link"
              >
                View media kit &gt;
              </Button>
            </div>
          </div>
          <div className="hidden md:col-start-9 md:col-end-13 md:block">
            <img src={PARTNERSHIP_IMAGE_URL} className="w-full" />
          </div>
        </div>
      </Container>
    </div>
  );
};
export default PartnershipOpportunitiesSection;
